export const environment = {
  production: false,
  baseApiUrl: 'https://metodicsplatform.gestatek.com',
  baseAuthUrl: 'https://metodicsplatform.gestatek.com/authentication',
};
